module.exports = __webpack_public_path__ + "assets/img/7091258ecb3ea2f164c47afa5160af46.svg";